var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8787 7.70705C23.0503 6.53548 24.9497 6.53547 26.1213 7.70705L42.7071 24.2928C43.0976 24.6834 43.0976 25.3165 42.7071 25.7071C42.3166 26.0976 41.6834 26.0976 41.2929 25.7071L24.7071 9.12126C24.3166 8.73074 23.6834 8.73074 23.2929 9.12126L6.70711 25.7071C6.31658 26.0976 5.68342 26.0976 5.29289 25.7071C4.90237 25.3165 4.90237 24.6834 5.29289 24.2928L11 18.5857V10.9999C11 10.4477 11.4477 9.99994 12 9.99994C12.5523 9.99994 13 10.4477 13 10.9999V16.5857L21.8787 7.70705Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 23.9999C11.5523 23.9999 12 24.4477 12 24.9999V38.9999C12 40.1045 12.8954 40.9999 14 40.9999H33C34.1046 40.9999 35 40.1045 35 38.9999V24.9999C35 24.4477 35.4477 23.9999 36 23.9999C36.5523 23.9999 37 24.4477 37 24.9999V38.9999C37 41.2091 35.2091 42.9999 33 42.9999H14C11.7909 42.9999 10 41.2091 10 38.9999V24.9999C10 24.4477 10.4477 23.9999 11 23.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNv);
export default __webpack_public_path__ + "static/media/Home_nv.faaef43ab112d79ba48fffc175d837c8.svg";
export { ForwardRef as ReactComponent };